// token
export const CLIENT_ID = 'nazauth';
export const ACCESS_TOKEN = 'naz-token';
export const REFRESH_TOKEN = 'naz-refrresh-token';
export const REFRESH_TOKEN_FAILED = 100;
export const REDIRECT_LOGOUT_URI: string = '/login';
export const SYSTEM_ID = 1;
export const PAGINATION_SIZE =10;
export const USERID='uid';
export const CLIENT_ID_ENOTIFICATION_SEC_VAL: String = 'secret';
//export const env='http://localhost:9190/nazouki/';
export const env='http://15.235.12.147:9190/nazouki/';
// OAuth API
export const  AUTH_TOKEN_API = 'OauthServer/oauth/token';
export const  REFRESH_TOKEN_API = 'OauthServer/oauth/token?grant_type=refresh_token&refresh_token=';
export const  FIND_USER_BY_LOGIN_AND_SYSTEM = 'OauthServer/user/findUserByLoginAndSystem';

//Organism API
export const SAVE_ORGANISM=env+'api/partner/organism/create';

//partner master
export const SAVE_DEPARTMENT=env+'api/master/department/create';
export const SAVE_ADDRESS=env+'api/master/address/create';
export const SAVE_CONTACT=env+'api/master/employee/create';

//Hospital Api
export const SAVE_HOSPITAL=env+'api/partner/hospital/create';
export const SAVE_PARTNER_SPECIALITY=env+'api/partner/partner-specialities/create';
export const SAVE_PARTNER_SUB_SPECIALITY=env+'api/partner/partner-sub-specialities/create';
export const SAVE_PARTNER_HYPER_SPECIALITY=env+'api/partner/partner-hyper-specialities/create';

//Master Api

export const GET_COUNTRY_MASTER=env+'api/master/country';
export const GET_CURRENCY_MASTER=env+'api/master/currency';
export const GET_LEGALFORM_MASTER=env+'api/master/legalForm';
export const GET_EMPLOYEE_MASTER=env+'api/master/employee';
export const GET_ORGANISM_MASTER=env+'api/partner/organism';
export const GET_ADDRESS_MASTER=env+'api/master/address';
export const GET_DEPARTMENT_MASTER=env+'api/master/department';
export const GET_LOCALE_MASTER=env+'api/master/locale';
export const GET_NATIONALITY_MASTER=env+'api/master/nationality';
export const GET_TOWN_MASTER=env+'api/master/town';
export const GET_CATEGORY_MASTER=env+'api/master/partner/category';
export const GET_CATEGORY_TYPE_MASTER=env+'api/master/partner/category-type';
export const GET_SPECIALITY_TYPE_MASTER=env+'api/partner/master/specialities';
export const GET_SUB_SPECIALITY_TYPE_MASTER=env+'api/partner/master/sub-specialities';
export const GET_HYPER_SPECIALITY_TYPE_MASTER=env+'api/partner/master/hyper-specialities';
export const GET_LANGUAGE_MASTER=env+'api/master/languages';
export const USER_SERCH=env+'api/user/search';
export const CREATE_USER=env+'api/user/create';
export const CREATE_SUB_PROFILE=env+'api/user/subProfile/create';
export const MAP_PROFILE_PRIVILAGE=env+'api/user/mapProfilePrivilage';
export const MAP_PROFILE_MENU=env+'api/user/mapProfileMenu';
export const GET_MASTERS_BY_PARAM_KEY=env+'api/medicalfile/masterByParamKeys';
export const GET_DISTINCT_MASTERS_PARAM_KEY=env+'api/medicalfile/master/param/keys';
export const GET_MASTERS_CODES_BY_PARAM_KEY=env+'api/medicalfile/master/codes';
export const PARTNER_ORGANISM_TYPE=1;
export const PARTNER_HOSPITAL_TYPE=2;
export const PARTNER_PHARMACY_TYPE=3;
export const PARTNER_PRACTITIONER_TYPE=4;
export const PARTNER_LOGISTICS_TYPE=7;
export const PARTNER_INSURANCE_TYPE=9;
export const PARTNER_FINANCIAL_TYPE=8;
export const PARTNER_TELEMEDICINE_TYPE=5;
export const PARTNER_ADMINISTRATION_TYPE=6;
export const PATIENT=10;


//Dashboard
export const GET_PARTNER_TOTAL_COUNT=env+'api/partner/partner/count';
export const GET_PARTNER_COUNT_BY_TYPE=env+'api/partner/partner/countByType';
export const GET_TOP5_PARTNERS=env+'api/partner/partners/topfive';
export const CHANGE_PASSWORD=env+'api/user/changePassword';
//Practitioner api

export const PRACTITIONER_SAVE=env+ "api/partner/practitioner/create";
export const TELEMEDICINE_SAVE=env+ "api/partner/telemedicine/create";
export const PHARMACY_SAVE=env+ "api/partner/pharmacy/create";
export const ADMINISTRATION_SAVE=env+ "api/partner/administrator/create";
export const EXCLUDED_URLS: string[] = ['authenticate'];
export const EXPIRES_IN: string = 'expires_in';
export const USER_ORGANISM: string = 'user_organism';
export const USER_PROFILE: string = 'user_profile';
export const USER_PRIVILAGE: string = 'user_privilage';
export const USER_SUB_PROFILE: string = 'user_sub_profile';
export const EMPLOYEE_NAME: string = 'emp_name';
export const USER_MENUS: string = 'user_menus';
export const FILE_STATUS: string = 'file_status';
//Master Param_keys

export const MARITAL_STATUS="MARITAL_STATUS";
export const GENDER="GENDER";
export const PATIENT_HISTORY="PATIENT_HISTORY";
export const FAMILY_HISTORY="FAMILY_HISTORY";
export const FAMILY_ATCD="FAMILY_ATCD";
export const TREATMENT_TYPE = "TREATMENT_TYPE";
export const STATUS = "STATUS";
export const ROUTE = "MEDICATION_ROUTE";
export const PRESENTATION = "PRESENTATION";
export const DOSAGE = "MEDICATION_DOSAGE";
export const PATIENT_CONDITION="PATIENT_CONDITION";
export const SUBJECTIVE_SIGN="SUBJECTIV_SIGN";
export const OBJECTIVE_SIGN="OBJECTIVE_SIGN";
export const TRANSFER_REUESTED_BY = "TRANSFER_REUESTED_BY";
export const TRANSFER_REASON = "TRANSFER_REASON";
export const TRANSFER_PLACE = "TRANSFER_PLACE";
export const TRF_FILE_STATUS = "TRF_FILE_STATUS";
export const TRANSFER_GEN_EME_LEVEL = "TRANSFER_GEN_EME_LEVEL";
export const TRANSFER_GEN_EME_TYPE = "TRANSFER_GEN_EME_TYPE";
export const BLOOD_GROUP = "BLOOD_GROUP";
export const RH_FACTOR = "RH_FACTOR";
export const TRANSFER_MED_PROCEDURE = "TRANSFER_MED_PROCEDURE";
export const TRANSFER_MED_EME_LEVEL = "TRANSFER_MED_EME_LEVEL";
export const TRANSFER_MED_EME_TYPE = "TRANSFER_MED_EME_TYPE";
export const TRANSFER_CONDITION_WAY = "TRANSFER_CONDITION_WAY";
export const TRANSFER_CONDITION_VEHICLE = "TRANSFER_CONDITION_VEHICLE";
export const TRANSFER_CONDITION_CLASS = "TRANSFER_CONDITION_CLASS";
export const TRANSFER_CONDITION = "TRANSFER_CONDITION";
export const TRANSFER_CONDITION_POSITION = "TRANSFER_CONDITION_POSITION";
export const ASSISTANCE_KIND = "ASSISTANCE_KIND";
export const ASSISTANCE_TYPE = "ASSISTANCE_TYPE";
export const ASSISTANCE_ACTOR = "ASSISTANCE_ACTOR";
export const SPECIALIST = "SPECIALIST";
export const HOSPITAL = "HOSPITAL";
export const TRANSFER = "TRANSFER";
export const PREFERRED_LOCATION = "PREFERRED_LOCATION";
export const ALLERGY = "ALLERGY";
export const ASSISTANCE = "ASSISTANCE";
export const HOSP_SURGERY_TRANSFER_TO = "HOSP_SURGERY_TRANSFER_TO";
export const HOSP_SURGERY_OPINION = "HOSP_SURGERY_OPINION"; 
export const HOSPI_REPORT_WAY = "HOSPI_REPORT_WAY";

export const TRANSFER_ACCEPTANCE = "TRANSFER_ACCEPTANCE";
export const DUTY = "DUTY";
export const MEDICAL_BACKGROUND = "MEDICAL_BACKGROUND";
export const COST_BEAR = "COST_BEAR";
export const MED_ADMIN_PAT_TRANSFER = "MED_ADMIN_PAT_TRANSFER";
export const MED_ADMIN_COMPANION = "MED_ADMIN_COMPANION";
export const MED_ADMIN_FILE_FOLLOW  ="MED_ADMIN_FILE_FOLLOW";
export const MED_LOGISTIC_FOLLOW_ACCOMDATION = "MED_LOGISTIC_FOLLOW_ACCOMDATION";
export const MED_LOGISTIC_FOLLOW_OTHER = "MED_LOGISTIC_FOLLOW_OTHER";
export const FOLLOWUP_CATEGORY = "FOLLOWUP_CATEGORY";
export const ADMIN_FOLLOWUP_FROM ="ADMIN_FOLLOWUP_FROM";
export const ADMIN_FOLLOWUP_ANSWER_STATUS = "ADMIN_FOLLOWUP_ANSWER_STATUS";
export const MED_LOGISTIC_PAT_WISE= "MED_LOGISTIC_PAT_WISE";
export const  MED_LOGISTIC_PAT_LOGISTIC_PACKAGE = "MED_LOGISTIC_PAT_LOGISTIC_PACKAGE";
export const  MED_LOGISTIC_PAT_ACCOMDATION_PACKAGE ="MED_LOGISTIC_PAT_ACCOMDATION_PACKAGE";
export const  MED_LOGISTIC_PAT_LOGISTIC ="MED_LOGISTIC_PAT_LOGISTIC"
export const  MED_LOGISTIC_FOLLOW_TRANSPORT ="MED_LOGISTIC_FOLLOW_TRANSPORT";
export const  MED_LOGISTIC_PAT_ACCOMDATION = "MED_LOGISTIC_PAT_ACCOMDATION";
export const  LOGISTIC_PATIENT_PKG_TYPE = "L";
export const  MEDICAL_PATIENT_PACKAGE_TYPE = "M";
export const  PAT_ACCOMPANION_PKG_TYPE_MED= "M";
export const  PAT_ACCOMPANION_PKG_TYPE_LOG = "L";

export const LOGISTIC_CATEGORY = "LOGISTIC_CATEGORY";
export const LOGISTIC_MEDICAL_ACCOMADATION = "LOGISTIC_MEDICAL_ACCOMADATION";
export const LOGISTIC_CONCERNED = "LOGISTIC_CONCERNED";
export const LOGISTIC_RELATIONSHIP="LOGISTIC_RELATIONSHIP";
export const LOGISTIC_FLIGHT_TYPE ="LOGISTIC_FLIGHT_TYPE";
export const LOGISTIC_ACCOMADATION_TYPE="LOGISTIC_ACCOMADATION_TYPE";
export const LOGISTIC_ROOM_TYPE = "LOGISTIC_ROOM_TYPE";
export const LOGISTIC_FOLLOWUP_REASON ="LOGISTIC_FOLLOWUP_REASON";
export const LOGISTIC_FOLLOWUP_SPECIAL_NEED = "LOGISTIC_FOLLOWUP_SPECIAL_NEED";
export const LOGISTIC_PAYMENT = "LOGISTIC_PAYMENT";
export const LOGISTIC_FOLLOWUP_STATUS = "LOGISTIC_FOLLOWUP_STATUS";
export const LOGISTIC_FOLLOWUP_ACC_ACCESSIBILITY = "LOGISTIC_FOLLOWUP_ACC_ACCESSIBILITY";
export const LOGISTIC_FOLLOWUP_NUMBER = "LOGISTIC_FOLLOWUP_NUMBER";
export const DATE_WITH_HYPHEN: string = 'DD-MM-YYYY';

//Medical File
export const GET_DETAILS_BY_SERVICE_KEY=env+'api/medicalFile/';
export const TREATMENT_MED_FILE = "TREATMENT";
export const SPL_TREATMENT_MED_FILE = "MED_SPL_TREATMENT";
export const PROCEDURE_MED_FILE = "PROCEDURE";
export const EXAMINATION_MED_FILE = "EXAMINATION";
export const PROGRESS_MED_FILE = "PROGRESS";
export const RELATIONSHIP="RELATIONSHIP";

export const SPEC_EXAMINATION_TYPE_ID ="ES";
export const BIO_EXAMINATION_TYPE_ID ="EB";
export const IMG_EXAMINATION_TYPE_ID ="IS";
//Initial Examination
export const MED_SUBJECTIVE_SIGN = "MED_SUBJECTIVE_SIGN";
export const MED_OBJECTIVE_SIGN = "MED_OBJECTIVE_SIGN";
export const MED_ACTION = "MED_ACTION";
export const MED_SECOND_OPINION = "MED_SECOND_OPINION";
export const MED_URGENCY="URGENCY";
export const MED_QUESTIONS="MED_QUESTIONS";
export const MED_CASE_REVIEW_PRACT="MED_CASE_REVIEW_PRACT";
export const MED_CASE_AFFECTATIONS="MED_CASE_AFFECTATIONS";
export const MED_CASE_REVIEW_HOSP="MED_CASE_REVIEW_HOSP";
export const DOCUMENT_TYPE="DOCUMENT_TYPE";
export const AUDITABLE_ENTITY=["createdTime","modifiedTime","createdUser","modifiedUser"];
export const FILES_CONTEXT:string = 'files';

export const MED_SERVICE_PLAN = "MED_SERVICE_PLAN";
export const MED_LOGISTIC_SERVICE_PLAN = "MED_LOGISTIC_SERVICE_PLAN";
export const MED_DOC_RETRIEVE = "MED_DOC_RETRIEVE";
export const SERVICE_CATEGORY="SERVICE_CATEGORY";
export const SERVICE_SUB_CATEGORY="SERVICE_SUB_CATEGORY";
export const MED_VISITS="MED_VISITS";
export const MED_NEEDS="MED_NEEDS";
export const MED_DISCHARGE="MED_DISCHARGE";
//Admin File Followup type
export const ADMIN_MED_FOLLOWUP_TYPE_COMPANION="C";
export const ADMIN_MED_FOLLOWUP_TYPE_PATIENT="P";
export const HTTP_FAILED_STATUS_MSG : string = 'Failed to connect to server, Please check if HTTP server is running'; 
export const FAILED_ATTEMPTS: string = 'Account will be Locked After ATTEMPTS Attempts Only';
export const USER_ROLES="USER_ROLES";
export const FILE_NEW="NEW";
export const FILE_FTT="FTT";
export const FILE_CUR="CUR";
export const FILE_ARC="ARC";
export const SERVICE = 'CONS_SERVICE';
export const EMERGENCY = 'HOSPI_PLAN_EMERGENCY';
export const CONSLATION_TYPE = 'CONSULTATION_TYPE';
export const HOSPI_REASON = 'HOSPI_PLAN_REASON';
export const PROCEDURE_NAMES = 'PROCEDURE_NAMES';
//PRIVILAGES

export const PRIV_ADD_ORGANISM = 'ADD_ORGANISM';
export const PRIV_ADD_USER = 'ADD_ORGANISM';
export const PRIV_ADD_HOSPITAL = 'ADD_HOSPITAL';
export const PRIV_ADD_PRACTIONER = 'ADD_PRACTIONER';
export const PRIV_ADD_INSURANCE = 'ADD_INSURANCE';
export const PRIV_ADD_PHARMACY = 'ADD_PHARMACY';
export const PRIV_ADD_ADMINISTRATOR = 'ADD_ADMINISTRATOR';
export const PRIV_ADD_FINANCIAL= 'ADD_FINANCIAL';
export const PRIV_ADD_TELEMEDICINE = 'ADD_TELEMEDICINE';
export const PRIV_ADD_LOGISTICS = 'ADD_LOGISTICS';
export const PRIV_ADD_PATIENT = 'ADD_PATIENT';
export const PRIV_ADD_MASTERS = 'ADD_MASTERS';
export const PRIV_ADD_DEPARTMENT = 'ADD_DEPARTMENT';
export const PRIV_ADD_CONTACT = 'ADD_CONTACT';
export const PRIV_ADD_ADDRESS = 'ADD_ADDRESS';
export const PRIV_ADD_FILE = 'ADD_MED_FILE';
export const PARTNER_TYPE = 'PARTNER_TYPE';
export const PARTNER_ID = 'PARTNER_ID';
export const SEC_USER_ID = 'SEC_USER_ID';
export const USER_COUNTRY_ID = 'USER_COUNTRY_ID';